import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DateStamp from '@bibliocommons/date-stamp';

import cardShape from 'app/shapes/cardShape';

export function EventDateStamp({ card, intl, size }) {
  if (card.getIn(['event', 'startTime'])) {
    const date = moment.utc(card.getIn(['event', 'startTime'])).toDate();
    const month = intl.formatDate(date, { month: 'short' });
    const day = intl.formatDate(date, { day: 'numeric' });
    const dateStampSize = size ?? 'large';

    return <DateStamp className="cp-event-date-stamp" size={dateStampSize} month={month} day={day} />;
  }

  return null;
}

EventDateStamp.propTypes = {
  card: cardShape.isRequired,
  size: PropTypes.oneOf(['default', 'large'])
};

export default injectIntl(EventDateStamp);
